/**
 * Napocut Wishlist Manager
 * - LocalStorage primary (key: np_wishlist, JSON array of product handles)
 * - Initial seed from customer.metafields.napocut.wishlist on first load (read-only)
 * - Pub/sub model: 'np-wishlist:change' event fired on add/remove
 */
(function(){
  if (window.NpWishlist) return;

  var KEY = 'np_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; }
    catch(e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch(e){}
    document.dispatchEvent(new CustomEvent('np-wishlist:change', { detail: { items: arr } }));
  }
  function has(handle) {
    return read().indexOf(handle) !== -1;
  }
  function add(handle) {
    var arr = read();
    if (arr.indexOf(handle) === -1) {
      arr.push(handle);
      write(arr);
    }
    return arr;
  }
  function remove(handle) {
    var arr = read().filter(function(h){ return h !== handle; });
    write(arr);
    return arr;
  }
  function toggle(handle) {
    return has(handle) ? remove(handle) : add(handle);
  }
  function count() { return read().length; }
  function clear() { write([]); }

  // Seed from customer metafield on first load (logged-in only)
  // Theme injects window.npWishlistSeed = [...handles] before this script runs
  function seedFromCustomer() {
    if (!window.npWishlistSeed || !Array.isArray(window.npWishlistSeed)) return;
    var existing = read();
    var merged = existing.slice();
    window.npWishlistSeed.forEach(function(h){
      if (h && merged.indexOf(h) === -1) merged.push(h);
    });
    if (merged.length !== existing.length) write(merged);
  }
  seedFromCustomer();

  // Sync all heart icons on page based on current state
  function refreshButtons() {
    var arr = read();
    document.querySelectorAll('[data-np-wishlist-btn]').forEach(function(btn){
      var h = btn.dataset.npWishlistBtn;
      var active = arr.indexOf(h) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Hapus dari wishlist' : 'Tambah ke wishlist');
    });
    // Sync counter badge
    document.querySelectorAll('[data-np-wishlist-count]').forEach(function(el){
      var c = arr.length;
      el.textContent = c;
      el.classList.toggle('is-empty', c === 0);
    });
  }

  // Delegated click handler for heart icons
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-np-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    var h = btn.dataset.npWishlistBtn;
    if (!h) return;
    toggle(h);
    // Pulse animation
    btn.classList.add('is-pulse');
    setTimeout(function(){ btn.classList.remove('is-pulse'); }, 350);
  });

  // Re-sync on every change
  document.addEventListener('np-wishlist:change', refreshButtons);

  // Initial sync after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshButtons);
  } else {
    refreshButtons();
  }

  // Public API
  window.NpWishlist = {
    read: read, write: write, has: has, add: add, remove: remove,
    toggle: toggle, count: count, clear: clear
  };
})();
